import { createSlice } from "@reduxjs/toolkit";

export const inicialModificadores = {
  params: {
    limit: 20,
    page: 1,
    condicao: "containing",
  },
};

const initialState = () => {
  return inicialModificadores;
};

export const ModificadoresSlice = createSlice({
  name: "modificadores",
  initialState,
  reducers: {
    handleParams: (state, { payload }) => {
      const field = payload?.field;
      state.params[field] = payload?.value;
      return state;
    },
    handleSetSearch: (state, { payload }) => {
      if (payload?.isDelete) {
        delete state.params[payload?.field];
      } else {
        state.params[payload?.field] = payload?.value;
      }
    },
    handleResetFiltros: state => {
      state.params = { ...inicialModificadores.params };
    },
  },
});

export const { handleParams, handleSetSearch, handleResetFiltros } =
  ModificadoresSlice.actions;

export default ModificadoresSlice.reducer;
